import createAxiosInstance from "../../utils/axiosInstance";
import { decryptData, generateHex32 } from "../../helpers/crypto_helper";
import { jwtDecode } from "jwt-decode";


export const generateAuthToken = async (host, secret, accountId, productId) => {
  const url = `https://${host}/api/v1/`;
  const postParams = {
    "grant_type": "bearer_token",
    "account_id": accountId,
    "product_id": productId
  };

  try {
    const axiosInstance = createAxiosInstance(secret, url);
    const response      = await axiosInstance.post('generate_auth_token?ap',postParams);
    return response.data.data;
  } catch(err) {
    console.log(err);
  }
}

export const getMessageCount = async (params) => {

  const url = params.host;
  const postParams = {
    userId: params.userId
  };

  try {
    const axiosInstance = createAxiosInstance(params.accessToken, url);
    const response      = await axiosInstance.post('getmessagecount',postParams);
    return response;
  } catch(err) {
    console.log(err);
  }
}

export const generateAuthenticationTokens = async (accessToken, onlyAllowedProducts = false) => {
  const decodedData = jwtDecode(accessToken);
  const accesskey   = `${decodedData.account_id}_${decodedData.us_uuid}_` + generateHex32();
  try {
    const axiosInstance = createAxiosInstance(accessToken);
    let response;
    if (onlyAllowedProducts) {
      response = await axiosInstance.post('generate-auth-token?token=0',{"access_key": accesskey});
    } else {
      response = await axiosInstance.post('generate-auth-token',{"access_key": accesskey});
    }
    if (response && response?.data) {
      const { allowed_products, user_sp_map, ...authTokens} = response?.data?.data;
      const newResponse = {
        'allowed_products': decryptData(allowed_products, accesskey),
        'user_sp_enabled' : user_sp_map,
        'auth_tokens': authTokens
      }
      return newResponse;
    }
  } catch(err) {
    console.log(err);
  }
}

